const pisVariables = {
    bindings: {
    },
    templateUrl: '/modules/pis-tool/variables/pis-variables.html',
    controller: 'PisVariablesController',
  };
  
  angular
    .module('pis-tool.module')
    .component('pisVariables', pisVariables)
    .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.variables', {
        url: '/variables',
        views: {
          'pisview@pis': 'pisVariables',
        },
        resolve: {
        },
      });
    });
  